import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const BulkEditTypeSelectWrapper = styled.div`
  margin: 4px 0px 16px;
  .header-right {
    text-align: end;
    margin-top: 16px;
  }
  .radio-button-container {
    margin: 24px 16px;
    ${responsive.MOBILE`
      margin: 16px;
    `}
  }
  .transfer-filed {
    margin: 24px 16px;
    width: 320px;
  }
  .MuiAccordionSummary-expandIconWrapper {
    display: none;
  }

  .accordion-container {
    padding: 0 16px 0 16px;
    margin-top: 54px;
    .role-header-text {
      margin-top: 24px;
      color: ${COLORS.cirrus_black10};
    }
  }
  .MuiAccordionDetails-root {
    padding-bottom: 30px;
    ${responsive.MOBILE`
      padding-bottom: 0px;
    `}
  }
`;
export const BulkEditTypeSelectFooterWrapper = styled.div`
  margin: 32px 0px;
  background-color: ${COLORS.cirrus_white};
  padding: 32px 16px 20px;
  display: flex;
  justify-content: flex-end;
  ${responsive.MOBILE`
      padding: 16px;
      margin: 0px;
  `}
`;
